var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3860_2189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 5.5C16.6 5.5 17.5 4.6 17.5 3.5C17.5 2.4 16.6 1.5 15.5 1.5C14.4 1.5 13.5 2.4 13.5 3.5C13.5 4.6 14.4 5.5 15.5 5.5ZM5 12C2.2 12 0 14.2 0 17C0 19.8 2.2 22 5 22C7.8 22 10 19.8 10 17C10 14.2 7.8 12 5 12ZM5 20.5C3.1 20.5 1.5 18.9 1.5 17C1.5 15.1 3.1 13.5 5 13.5C6.9 13.5 8.5 15.1 8.5 17C8.5 18.9 6.9 20.5 5 20.5ZM10.8 10.5L13.2 8.1L14 8.9C15.06 9.96 16.38 10.68 17.96 10.92C18.56 11.01 19.1 10.53 19.1 9.92C19.1 9.43 18.73 9.01 18.25 8.93C17.14 8.75 16.23 8.22 15.5 7.5L13.6 5.6C13.1 5.2 12.6 5 12 5C11.4 5 10.9 5.2 10.6 5.6L7.8 8.4C7.4 8.8 7.2 9.3 7.2 9.8C7.2 10.4 7.4 10.9 7.8 11.2L11 14V18C11 18.55 11.45 19 12 19C12.55 19 13 18.55 13 18V13.6C13 13.08 12.8 12.59 12.45 12.22L10.8 10.5ZM19 12C16.2 12 14 14.2 14 17C14 19.8 16.2 22 19 22C21.8 22 24 19.8 24 17C24 14.2 21.8 12 19 12ZM19 20.5C17.1 20.5 15.5 18.9 15.5 17C15.5 15.1 17.1 13.5 19 13.5C20.9 13.5 22.5 15.1 22.5 17C22.5 18.9 20.9 20.5 19 20.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3860_2189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBike);
export default __webpack_public_path__ + "static/media/bike.3a7832d1fa1b6e4b1ab46e133b79fce2.svg";
export { ForwardRef as ReactComponent };